import React from 'react'
import Main from '../cpn/Main'
import { Alert } from 'antd'
import { useNavigate } from 'react-router-dom'

function NoPower() {
    const navi = useNavigate()
    return (
        <Main>
            <Alert
                message="对不起，你没有这个页面的权限"
                description="请联系系统管理员获取更多信息！"
                type="warning"
                showIcon
                closable
                onClose={() => {
                    navi('/SysIndex')
                }}
            />
        </Main>
    )
}

export default NoPower